module.exports = __webpack_public_path__ + "img/rectangle.754e6606.svg";